import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Grid,  CardContent, Box, Typography } from "@material-ui/core";

const ChatSkeleton = ( props ) => {

  const classes = props.classes

  return (
  <Grid className={classes.heightAdjust} item xs={12}  style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <CardContent style={{ flexDirection: 'column', justifyContent:'space-between', color: '#888' }} className={classes.EmptyF}>
        {/* <PortraitIcon style={{ fontSize: '5em'}} /> */}
        <Box style={{ marginBottom: 40, flex: 1,  width: '100%' }}>
          <Box pt={1} style={{display: 'flex', width: '100%', flex: 1, flexDirection: 'row', alignItems: 'center'}}>
            <Skeleton variant="circle" width={40} height={40} style={{marginRight: 10}} />
            <Box pt={1} style={{flex: 1, display: 'flex', width: '100%',  flexDirection: 'column'}}>
              <Skeleton width="60%" />
              <Skeleton width="30%" />
            </Box>
          </Box>            
          <Box pt={1} style={{display: 'flex', width: '100%', flex: 1, flexDirection: 'row-reverse', alignItems: 'center'}}>
            <Skeleton variant="circle" width={40} height={40} style={{ marginLeft: 10 }} />
            <Box pt={1} style={{flex: 1, display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'flex-end'}}>
              <Skeleton width="60%" />
              <Skeleton width="30%" />
            </Box>
          </Box>
          <Box pt={1} style={{display: 'flex', width: '100%', flex: 1, flexDirection: 'row', alignItems: 'center'}}>
            <Skeleton variant="circle" width={40} height={40} style={{marginRight: 10}} />
            <Box pt={1} style={{flex: 1, display: 'flex', width: '100%', flexDirection: 'column'}}>
              <Skeleton width="60%" />
              <Skeleton width="30%" />
            </Box>
          </Box>
          <Box pt={1} style={{display: 'flex', width: '100%', flex: 1, flexDirection: 'row-reverse', alignItems: 'center'}}>
            <Skeleton variant="circle" width={40} height={40} style={{ marginLeft: 10 }} />
            <Box pt={1} style={{flex: 1, display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'flex-end'}}>
              <Skeleton width="60%" />
              <Skeleton width="30%" />
            </Box>
          </Box>
          <Box pt={1} style={{display: 'flex', width: '100%', flex: 1, flexDirection: 'row', alignItems: 'center'}}>
            <Skeleton variant="circle" width={40} height={40} style={{marginRight: 10}} />
            <Box pt={1} style={{flex: 1, display: 'flex', width: '100%', flexDirection: 'column'}}>
              <Skeleton width="60%" />
              <Skeleton width="30%" />
            </Box>
          </Box>
        </Box>            
        <Typography variant="h5"> 
          Selecciona una conversación 
        </Typography>
      </CardContent>
    </Grid>
  )};

  export default ChatSkeleton;